/**
 * @generated SignedSource<<f05915d9b0e12a8b66a972535cc2a62a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NftTokenContractTokenStandard = "NFT_TOKEN_CONTRACT_TOKEN_STANDARD_ERC1155" | "NFT_TOKEN_CONTRACT_TOKEN_STANDARD_ERC721" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionViewToolbar_contractImport$data = {
  readonly contract: {
    readonly tokenStandard: NftTokenContractTokenStandard | null;
  } | null;
  readonly contractAddress: {
    readonly address: string | null;
  } | null;
  readonly " $fragmentType": "NftProfileImportCollectionViewToolbar_contractImport";
};
export type NftProfileImportCollectionViewToolbar_contractImport$key = {
  readonly " $data"?: NftProfileImportCollectionViewToolbar_contractImport$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionViewToolbar_contractImport">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftProfileImportCollectionViewToolbar_contractImport",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "contractAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftTokenContract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tokenStandard",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftTokenContractImport",
  "abstractKey": null
};

(node as any).hash = "0d908a876ef45b6387178d8f8789ead4";

export default node;
